import React, { Component } from 'react';
import {
	ResponsiveContainer, Tooltip, Legend, CartesianGrid, XAxis, YAxis,
	BarChart, Bar,
	Brush
} from 'recharts';
import BlockUi from 'react-block-ui';
import chartUtils, { COLORS } from '../utils';

class LessonsInPeriod extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { loading, data, height = 300 } = this.props;
		const timeSeriesData = chartUtils.prepareTimeSeriesData(data);

		let allGrades = {}; 

		if (timeSeriesData) {
			timeSeriesData.forEach(entry => {
				if (entry.grades) {
					entry.grades.forEach(grade => {
						allGrades[grade.name] = grade.shortName;					
						entry[grade.name] = grade.value;
					});
				}
			});
		}

		const renderLegendText = (value, entry, index) => {
			return <span >{allGrades[value]}</span>;
		};

		return <BlockUi blocking={loading}>
			<ResponsiveContainer height={height}>
				<BarChart data={timeSeriesData} barSize={40}>
					<XAxis dataKey='timestamp' scale='time' type='number' domain={['dataMin', 'dataMax']} tickFormatter={chartUtils.formatUnixTime}	padding={{ left: 20, right: 20 }} />
					<YAxis axisLine={false} tickLine={false} />
					<CartesianGrid vertical={false} />
					<Tooltip labelFormatter={label => chartUtils.formatUnixTime(label, 'll')} />
					<Legend formatter={renderLegendText} />
					{Object.keys(allGrades).map((grade, index) => <Bar key={index} stackId='grade' dataKey={grade} fill={COLORS[index % COLORS.length]} />)}
					{data && data.length > 1 && <Brush height={25} />}
				</BarChart>
			</ResponsiveContainer>
		</BlockUi>;
	}
}

export default LessonsInPeriod;